module.exports = __webpack_public_path__ + "img/logo-dark.77cd815a.png";